const config = {
    apiUrl: 'https://rentsmart.es/ticka/api'
};
  
export default config;